import { Snippet } from 'ui/icons';

import { testIds } from '../../../constants';
import { useSnippetSelectorContext } from '../../../contexts/SnippetSelectorContext';
import { useTranslations } from '../../../hooks/useTranslations';
import { ToolbarButton } from './BaseInsertButton';

export const SnippetSelectorButton = () => {
  const { t } = useTranslations();
  const { showSnippetSelector } = useSnippetSelectorContext();

  return (
    <ToolbarButton
      onClick={showSnippetSelector}
      testId={testIds.toolbarBtnSnippets}
      tooltip={t('tooltip.buttonSnippet')}
    >
      <Snippet isColorInherited />
      <span>{t('button.snippets')}</span>
    </ToolbarButton>
  );
};
